<script>
import {
  cooperationComputed,
  cooperationMethods,
} from '@state/cooperationHelpers.js'
import store from '@state/store'
import Loading from '@views/_loading.vue'
import isEmpty from 'lodash/isEmpty'
import i18n from '@/i18n'
import { VALIDATE_NUMBER } from '@/constants/regex/validate'
import formatNumberFullSize from '@utils/format-number-full-size'
import coop from './listSetting'

export default {
  coop,
  page: {
    title: 'Cooperation',
    meta: [{ name: 'description', content: 'The Cooperation page.' }],
  },
  components: { Loading },
  data: function() {
    return {
      items: coop,
      checkValue: {
        qr_interval: 1,
        tenkey_interval: 0,
      },
      checkFlag: true,
      checkChange: true,
      isShowMailSetting: false,
      isShowDeleteDays: false,
      isShowBccAddress: false,
      completeActionDeleteUser: 1,
    }
  },
  computed: {
    ...cooperationComputed,
    computedLoading() {
      return this.getIsLoading
    },
    computedItems() {
      return this.items?.map((item) => {
        if (item.key !== 'group_user_no') {
          item.value = !isEmpty(this.getListSettingUser)
            ? this.getListSettingUser[item.key]
            : item.value
          item.default = !isEmpty(this.getListSettingUser)
            ? this.getListSettingUser[item.key]
            : item.default
        }
        if (
          item.key === 'group_user_no' &&
          !isEmpty(this.getUserGroupDetail) &&
          !isEmpty(this.getListSettingUser) &&
          this.checkChange
        ) {
          this.checkChange = false
          const value = this.getUserGroupDetail.filter(
            (x) => x.user_group_no === this.getListSettingUser[item.key]
          )
          item.value =
            value.length > 0 ? this.getListSettingUser[item.key] : null
          item.default =
            value.length > 0 ? this.getListSettingUser[item.key] : null
          this.getUserGroupDetail.forEach((data) => {
            const dataTest = {
              value: data.user_group_no,
              text: data.name,
            }
            item.data.push(dataTest)
          })
        }
        if (item.key === 'cancel_action') {
          if (
            this.getListSettingUser.reserve_action === 1 ||
            this.getListSettingUser.reserve_action === 2
          ) {
            item.value = this.getListSettingUser.cancel_action
            item.data = [
              {
                value: 1,
                text: '入室申請を取り消す',
              },
              {
                value: 3,
                text: '何もしない',
              },
            ]
          } else if (
            this.getListSettingUser.reserve_action === 3 ||
            this.getListSettingUser.reserve_action === 4
          ) {
            item.value = this.getListSettingUser.cancel_action
            item.data = [
              {
                value: 2,
                text: 'ユーザを無効に設定する',
              },
              {
                value: 3,
                text: '何もしない',
              },
            ]
          } else if (this.checkFlag) {
            this.checkFlag = false
            item.data = [
              {
                value: 1,
                text: '入室申請を取り消す',
              },
              {
                value: 3,
                text: '何もしない',
              },
            ]
          }
        }
        if (item.key === 'tenkey_interval') {
          if (this.getListSettingUser.qr_interval === 0) {
            item.value = this.getListSettingUser.tenkey_interval || item.value
            item.data = [
              {
                value: 1,
                text: '固定',
              },
              {
                value: 2,
                text: '予約毎に変更',
              },
              {
                value: 3,
                text: '1分毎に変更（OTP）',
              },
              {
                value: 4,
                text: '1分毎に変更（OTP）、表示端末を限定する',
              },
            ]
          }
        }
        if (item.key === 'email_use_user_mail') {
          if (this.getListSettingUser.email_use_user_mail !== undefined) {
            this.isShowMailSetting = this.getListSettingUser[item.key]
            item.value = this.getListSettingUser[item.key]
          }
        }
        if (item.key === 'email_use_bcc') {
          if (this.getListSettingUser.email_bcc !== undefined) {
            item.value = this.getListSettingUser.email_bcc !== ''
            this.isShowBccAddress = this.getListSettingUser.email_bcc !== ''
          }
        }
        if (item.key === 'complete_action') {
          item.value = this.getListSettingUser.complete_action
          this.isShowDeleteDays =
            this.getListSettingUser.complete_action ===
            this.completeActionDeleteUser
        }
        if (item.key === 'min_user_id') {
          if (this.getUserMaxNum) {
            item.validate = [
              (v) => VALIDATE_NUMBER.test(v) || i18n.t('errorMinimumUserId'),
              (v) => v >= 1 || i18n.t('errorMinimumUserId'),
              (v) =>
                v <= 999999 ||
                formatNumberFullSize(v) <= 999999 ||
                i18n.t('errorMinimumUserId'),
              (v) => v <= this.getUserMaxNum || i18n.t('errorMaxUserNum'),
            ]
          }
        }
        return item
      })
    },
    computedUpdateSuccess() {
      return this.updateListSettingSuccess
    },
  },
  watch: {
    computedUpdateSuccess() {
      if (this.computedUpdateSuccess) this.getListSettingParams()
    },
  },
  created() {
    store.dispatch('snackbar/resetSnackbar')
    this.getUserGroupList()
    this.getListSettingParams()
    this.getUserMaxNumParams()
  },
  methods: {
    ...cooperationMethods,
    handleSubmit() {
      const dataTransformed = {
        email_template: {},
      }

      if (!this.$refs.form.validate()) {
        return
      }
      this.items.forEach((item) => {
        switch (item.key) {
          case 'email_title':
            dataTransformed.email_template.title = item.value
            break
          case 'email_template':
            dataTransformed.email_template.body = item.value
            break
          case 'email_use_user_mail':
            dataTransformed.email_template.use_user_mail = item.value
            break
          case 'email_bcc':
            if (item.value !== '') {
              dataTransformed.email_template.bcc = item.value
            }
            break
          case 'email_host':
            dataTransformed.email_template.host = item.value
            break
          case 'email_port':
            dataTransformed.email_template.port = item.value
            break
          case 'email_use_ssl':
            dataTransformed.email_template.use_ssl = item.value
            break
          case 'email_user':
            dataTransformed.email_template.user = item.value
            break
          case 'email_from':
            dataTransformed.email_template.from = item.value
            break
          case 'email_pass':
            dataTransformed.email_template.pass = item.value
            break
          default:
            dataTransformed[item.key] = item.value
        }
      })
      dataTransformed.email_template = JSON.stringify(
        dataTransformed.email_template
      )
      this.updateListSettingParams({ setting_data: dataTransformed })
    },
    handleChange(v, key) {
      this.checkValue[key] = v
      if (key === 'reserve_action') {
        const reserveAction = this.items.find(
          (item) => item.key === 'reserve_action'
        )
        const cancelAction = this.items.find(
          (item) => item.key === 'cancel_action'
        )
        if (reserveAction.value === 1 || reserveAction.value === 2) {
          if (cancelAction.value === 2) cancelAction.value = 1
          cancelAction.data = [
            {
              value: 1,
              text: '入室申請を取り消す',
            },
            {
              value: 3,
              text: '何もしない',
            },
          ]
        }
        if (reserveAction.value === 3 || reserveAction.value === 4) {
          if (cancelAction.value === 1) cancelAction.value = 2
          cancelAction.data = [
            {
              value: 2,
              text: 'ユーザを無効に設定する',
            },
            {
              value: 3,
              text: '何もしない',
            },
          ]
        }
      }
      if (key === 'qr_interval') {
        const qrInterval = this.items.find((item) => item.key === 'qr_interval')
        const tenkeyInterval = this.items.find(
          (item) => item.key === 'tenkey_interval'
        )
        if (qrInterval.value === 0) {
          if (tenkeyInterval.value === 0) tenkeyInterval.value = 1
          tenkeyInterval.data = [
            {
              value: 1,
              text: '固定',
            },
            {
              value: 2,
              text: '予約毎に変更',
            },
            {
              value: 3,
              text: '1分毎に変更（OTP）',
            },
            {
              value: 4,
              text: '1分毎に変更（OTP）、表示端末を限定する',
            },
          ]
        }
        if (qrInterval.value === 1 || qrInterval.value === 2) {
          if (tenkeyInterval.value > 2) tenkeyInterval.value = 0
          tenkeyInterval.data = [
            {
              value: 0,
              text: '使用しない',
            },
            {
              value: 1,
              text: '固定',
            },
            {
              value: 2,
              text: '予約毎に変更',
            },
          ]
        }
        if (qrInterval.value === 3) {
          if (
            tenkeyInterval.value === 1 ||
            tenkeyInterval.value === 2 ||
            tenkeyInterval.value === 4
          )
            tenkeyInterval.value = 0
          tenkeyInterval.data = [
            {
              value: 0,
              text: '使用しない',
            },
            {
              value: 3,
              text: '1分毎に変更（OTP）',
            },
          ]
        }
        if (qrInterval.value === 4) {
          if (
            tenkeyInterval.value === 1 ||
            tenkeyInterval.value === 2 ||
            tenkeyInterval.value === 3
          )
            tenkeyInterval.value = 0
          tenkeyInterval.data = [
            {
              value: 0,
              text: '使用しない',
            },
            {
              value: 4,
              text: '1分毎に変更（OTP）、表示端末を限定する',
            },
          ]
        }
      }
    },
    cancelDataTranformed() {
      this.items = this.items?.map((item) => {
        item.value = item.default
        return item
      })
    },
    handleChangeMailSetting(event) {
      this.isShowMailSetting = event
    },
    handleChangeCompletionAction(event) {
      if (event === this.completeActionDeleteUser) {
        this.isShowDeleteDays = true
      } else {
        this.isShowDeleteDays = false
      }
    },
    handleChangeMailBcc(event) {
      if (!event) {
        this.items.forEach((item) => {
          if (item.key === 'email_bcc') item.value = ''
        })
      }
      this.isShowBccAddress = event
    },
  },
}
</script>

<template>
  <div id="idoors-cooperation">
    <BaseSubHeader />
    <v-form ref="form" class="mt-7 mb-8" @submit.prevent="handleSubmit">
      <v-card
        class="pt-6 pb-6 pl-4 pr-4 mb-4 rounded-lg form-scroll"
        elevation="3"
      >
        <v-container>
          <v-row v-for="(item, i) in computedItems" :key="`group-${i}`">
            <v-col v-if="!item.child" cols="12" sm="12" md="4">
              {{ $t(item.title) }}
              <span v-if="item.require" class="color_red">*</span>
            </v-col>
            <v-col
              v-else-if="item.key === 'delete_days' && isShowDeleteDays"
              class="pl-15"
              cols="12"
              sm="12"
              md="4"
            >
              {{ $t(item.title) }}
              <span v-if="item.require" class="color_red">*</span>
            </v-col>
            <v-col
              v-else-if="item.key === 'email_bcc' && isShowBccAddress"
              class="pl-15"
              cols="12"
              sm="12"
              md="4"
            >
              {{ $t(item.title) }}
              <span v-if="item.require" class="color_red">*</span>
            </v-col>
            <v-col
              v-else-if="
                (item.key === 'email_host' ||
                  item.key === 'email_port' ||
                  item.key === 'email_use_ssl' ||
                  item.key === 'email_user' ||
                  item.key === 'email_from' ||
                  item.key === 'email_pass') &&
                  isShowMailSetting
              "
              class="pl-15"
              cols="12"
              sm="12"
              md="4"
            >
              {{ $t(item.title) }}
              <span v-if="item.require" class="color_red">*</span>
            </v-col>
            <v-col
              v-if="item.key === 'email_use_user_mail'"
              cols="12"
              sm="12"
              md="8"
            >
              <v-switch
                v-model="item.value"
                inset
                class="ma-0 pa-0"
                @change="handleChangeMailSetting"
              ></v-switch>
            </v-col>
            <v-col
              v-else-if="
                item.key === 'group_user_no' ||
                  item.key === 'reserve_action' ||
                  item.key === 'cancel_action' ||
                  item.key === 'qr_interval' ||
                  item.key === 'tenkey_interval'
              "
              cols="12"
              sm="12"
              md="8"
            >
              <v-select
                v-model="item.value"
                :items="item.data"
                item-text="text"
                item-value="value"
                outlined
                color="black"
                background-color="white"
                dense
                hide-details="auto"
                :rules="item.validate"
                @change="(v) => handleChange(v, item.key)"
              />
            </v-col>
            <v-col
              v-else-if="item.key === 'delete_days' && isShowDeleteDays"
              cols="12"
              sm="12"
              md="8"
            >
              <v-select
                v-model="item.value"
                :items="item.data"
                item-text="text"
                item-value="value"
                outlined
                color="black"
                background-color="white"
                dense
                hide-details="auto"
              />
            </v-col>
            <v-col
              v-else-if="item.key === 'email_template'"
              cols="12"
              sm="12"
              md="8"
            >
              <v-textarea
                v-model="item.value"
                outlined
                color="black"
                background-color="white"
                dense
                :rules="item.validate"
                hide-details="auto"
              />
            </v-col>
            <v-col
              v-else-if="item.key === 'email_use_bcc'"
              cols="12"
              sm="12"
              md="8"
            >
              <v-switch
                v-model="item.value"
                inset
                class="ma-0 pa-0"
                @change="handleChangeMailBcc"
              ></v-switch>
            </v-col>
            <v-col
              v-else-if="item.key === 'email_bcc' && isShowBccAddress"
              cols="12"
              sm="12"
              md="8"
            >
              <v-text-field
                v-model="item.value"
                outlined
                color="black"
                background-color="white"
                dense
                :rules="item.validate"
                hide-details="auto"
              />
            </v-col>
            <v-col
              v-else-if="
                isShowMailSetting &&
                  (item.key === 'email_host' ||
                    item.key === 'email_port' ||
                    item.key === 'email_user' ||
                    item.key === 'email_from' ||
                    item.key === 'email_pass')
              "
              cols="12"
              sm="12"
              md="8"
            >
              <v-text-field
                v-model="item.value"
                outlined
                color="black"
                background-color="white"
                dense
                :rules="item.validate"
                hide-details="auto"
              />
            </v-col>
            <v-col
              v-else-if="item.key === 'email_use_ssl' && isShowMailSetting"
              cols="12"
              sm="12"
              md="8"
            >
              <v-switch v-model="item.value" inset class="ma-0 pa-0"></v-switch>
            </v-col>
            <v-col
              v-else-if="item.key === 'complete_action'"
              cols="12"
              sm="12"
              md="8"
            >
              <v-select
                v-model="item.value"
                :items="item.data"
                item-text="text"
                item-value="value"
                outlined
                color="black"
                background-color="white"
                dense
                hide-details="auto"
                @change="handleChangeCompletionAction"
              />
            </v-col>
            <v-col v-else-if="!item.child" cols="12" sm="12" md="8">
              <v-text-field
                v-model="item.value"
                outlined
                color="black"
                background-color="white"
                dense
                :rules="item.validate"
                hide-details="auto"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-col class=" d-flex justify-content-end">
        <v-btn
          color="primary"
          class="white--text custom_width custom_height mr-5"
          type="submit"
        >
          Submit
        </v-btn>
        <v-btn
          color="grey"
          class="white--text custom_height"
          type="button"
          @click="cancelDataTranformed"
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-col>
    </v-form>
    <Loading :loading="computedLoading" />
  </div>
</template>

<style lang="scss">
#idoors-cooperation {
  .form-scroll {
    height: 65vh;
    overflow-y: auto;
  }
  .custom_width {
    width: 100px !important;
  }
  .custom_height {
    height: 32px !important;
  }
  .color_red {
    padding-left: 5px;
    color: red;
  }
  .justify-content-end {
    justify-content: flex-end !important;
  }
  .idoor_snackbar_success {
    color: black !important;
    text-align: center !important;
  }
}
</style>
